document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const toggle = document.querySelector('.tco-theme-toggle');
  const name = 'STYXKEY_theme-last-visit';
  const themeCookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));
  const switchImages = document.querySelectorAll('.tco-image-switch');
  const fragments = document.querySelectorAll('.tco-headline-fragment');
  const blurbs = document.querySelectorAll('.tco-headline-statement');

  const setCookie = (name, value, days) => {
    let expires = '';

    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
  };

  if( themeCookie ) {
    toggle.checked = true;
  }

  const imageSwitch = (mode) => {
    // check for any images that need a different version
    if ( switchImages ) {
      switchImages.forEach((image) => {
        const srcDark = image.dataset.darkSrc;
        const srcsetDark = image.dataset.darkSrcset;
        const srcLight = image.dataset.lightSrc;
        const srcsetLight = image.dataset.lightSrcset;

        if ( mode === 'dark' ) {
          image.setAttribute('src', srcDark);
          image.setAttribute('srcSet', srcsetDark);

        } else if ( mode === 'light' ) {
          image.setAttribute('src', srcLight);
          image.setAttribute('srcSet', srcsetLight);
        }
      });
    }
  };

  const checkHeadlineAnimation = (mode) => {
    if ( fragments && blurbs ) {
      fragments.forEach(fragment => {
        fragment.getAnimations().forEach(animation => {
          animation.cancel();
          if ( mode === 'dark' && animation.animationName === 'colorFadeDark' ) {
            animation.play();
          } else if ( mode === 'light' && animation.animationName === 'colorFade' ) {
            animation.play();
          }
        });
      });
    }
  };

  toggle.addEventListener('click', () => {

    if( body.classList.contains('tco-lights-out') ) {
      // turn the lights on and clear cookie
      body.classList.remove('tco-lights-out');
      body.setAttribute('data-theme', 'light');
      setCookie( name, '', -1);
      imageSwitch('light');
      setTimeout(checkHeadlineAnimation('light'), 1000);

    } else { // switch to dark theme and set cookie
      body.classList.add('tco-lights-out');
      body.setAttribute('data-theme', 'dark');
      setCookie( name, 'dark', 365);
      imageSwitch('dark');
      setTimeout(checkHeadlineAnimation('dark'), 1000);
    }
  });
})